//import $ from 'jquery';

import { View } from 'backbone';
import { Model } from 'backbone';
import template  from 'dashboard/forms/modal/form-delete-modal.ejs';
import ConfirmDeleteModal from 'dashboard/forms/modal/ConfirmDeleteModal.js';
import NotificationService from 'NotificationService.js';
import listService  from 'ListService.js';

class FormDeleteModal extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.El = "#deleteModal";

        if (this.options) {
            this.width = this.options.width;
            this.height = this.options.height;
        }

        return this;
    }

    activateFields() {
        // Activate delete previous version option
        if (this.model.get('versionList') instanceof Array ){
            $('#deletePreviousPanel').removeClass('disabledPanel');
        } else if (this.model.get('versionList')['@MajorVersion'] !== '0'
                    && this.model.get('versionList')['@MajorVersion'] !== 0 ) {
            $('#deletePreviousPanel').removeClass('disabledPanel');
        }
        // Activate delete draft instance
        if (this.model.get('totalOpenInstances') > 0 ){
            $('#deleteDraftPanel').removeClass('disabledPanel');
        }

        if (this.model.get('hasMobileForm')){
            $('.mobileOptions').addClass('disabledPanel');
        }
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set(propName, propVal);
        $('button.btn-select-field').button("enable");
    }

    confirmDelete(){
        const confirmDeleteModal = new ConfirmDeleteModal({model: new Model({formName: this.model.get('formName'),
            formId: this.model.get('formId'), formLink: this.model.get('formLink'),
            versionList: this.model.get('versionList'), mode: this.model.get('toDelete'),
            groupType: this.model.get('groupType'), groupId: this.model.get('groupId')})});

        confirmDeleteModal.render().then( result => {
            return(result);
        }, rejectReason => {
            //this is to receive the rejection from the main window, 
            //no action required.
        }).catch((error) => {
            const msg = error || 'confirmDelete: unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    bindEvents() {
        $('input[type=radio][name=toDelete]').on("change", (e)=>{
            this.updateRadioAttributes(e);
        });
    }

    unbindEvents() {
        $('input[type=radio][name=toDelete]').off();
    }

    closeModal() {
        $(this.El).remove();
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);

            const self = this;

            this.dialog = $(self.El).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: this.height || 510,
                width: this.width || 520,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'OK',
                        'class':'btn-select-field',
                        'disabled': true,
                        click: () => {
                            self.unbindEvents();
                            this.dialog.dialog( "close" );
                            resolve(self.confirmDelete());
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn-addAssetCancel',
                        click: () => {
                            this.dialog.dialog("close");
                            this.closeModal();
                            reject();
                        }
                    }
                ],
                close: () => {
                    this.dialog.dialog("destroy");
                    this.closeModal();
                    listService.deleteDialogOpened = false; 
                },
                open: () =>{
                    self.bindEvents();
                    self.activateFields();
                    listService.deleteDialogOpened = true;   
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
            this.delegateEvents();
            return this;
        });
    }

}

export default FormDeleteModal;
